import { useEffect, useState } from 'react';
import styles from './IntroScreen.module.css';
import { useAppConfig } from '../../context/AppConfigContext'; // подключаем мультиязычность

const IntroScreen = ({ onContinue }) => {
  const [countdown, setCountdown] = useState(10);
  const { t } = useAppConfig(); // получаем переводы

  const steps = [
    t.lessons.step1, // "Словарь"
    t.lessons.step2, // "Сопоставление"
    t.lessons.step3, // "Построение фраз. Легко"
    t.lessons.step4, // "Построение фраз. Сложно"
    t.lessons.step5  // "Устный перевод"
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onContinue();
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [onContinue]);

  return (
    <div className={styles.introContainer}>
      <h2>{t.lessons.introTitle}</h2>
      <ul className={styles.steps}>
        {steps.map((label, index) => (
          <li key={index} className={styles.stepItem}>
            <div className={styles.circle}>{index + 1}</div>
            <span className={styles.stepLabel}>{label}</span>
          </li>
        ))}
      </ul>
      <button className={styles.readyButton} onClick={onContinue}>
        {t.lessons.readyButton}
      </button>
      <p className={styles.timer}>
        {t.lessons.autoStart.replace('{seconds}', countdown)}
      </p>
    </div>
  );
};

export default IntroScreen;

